import React, { useEffect } from 'react'
import { Box, Button } from '@material-ui/core'
import { SideBar } from '../../../components/side-bar'
import { navLinksProduct } from '../../../services/product'
import {
    storages
} from '../../../store/slices'
import { useAppDispatch } from '../../../store'
import { useSelector } from 'react-redux'
import { IStorage } from '../../../store/types'
import { FetchCollectionParams, FetchCreatedAtParams } from '../../../services/_common'
import { getIdFromIRI } from '../../../services/_common/utils'
import { DataTable } from '../../../components/dataTable'
import { Link } from 'react-router-dom'
import { ROUTES } from '../../../constants'


export function StoragesPage(): JSX.Element {

    const dispatch = useAppDispatch()
    const fetchStatus = useSelector(storages.selectors.fetchStatus)
    const totalItems = useSelector(storages.selectors.totalItems)

    useEffect(() => {
        dispatch(storages.actions.fetch({pagination: false}))
    }, [])

    return (
        <Box display="flex">
            <SideBar navLinks={navLinksProduct}>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    component={Link}
                    to={ROUTES.PRODUCT_STORAGES_CREATE}
                >
                    Создать
                </Button>
            </SideBar>
            <DataTable<IStorage, FetchCreatedAtParams & FetchCollectionParams>
                title={'Склады'}
                urlPathEdit={'/product/storages/edit'}
                fetchProps={{
                    page: 1,
                    perPage: 20,
                }}
                fetchAction={storages.actions.fetch}
                selector={storages.selectors.selectAll}
                deleteAction={storages.actions.remove}
                mappingFunction={(attribute) => ({
                    id: getIdFromIRI(attribute.id),
                    name: attribute.name,
                    coords: attribute.lat ? [attribute.lat, attribute.long].join(', ') : '',
                })}
                loading={fetchStatus.isFetching}
                columns={[
                    { field: 'id', headerName: 'ID', flex: 1, sortable: false, hide: true },
                    { field: 'name', headerName: 'Название', flex: 1, sortable: true },
                    { field: 'coords', headerName: 'Координаты', flex: 1, sortable: true },
                ]}
                rowCount={totalItems}
            >
            </DataTable>
        </Box>
    )
}